import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import ScrollToTop from "./ScrollToTop";
import MaintenancePage from "./components/MaintenancePage";
import AppointmentPage from "./pages/AppointmentPage";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const MAINTENANCE_MODE = false;

const theme = createTheme({
  palette: {
    primary: { main: "#1e293b" },
    secondary: { main: "#57a1d8" },
  },
});

const LANGUAGES = [
  { code: "en", label: "🇬🇧 English" },
  { code: "el", label: "🇬🇷 Ελληνικά" },
  // Προσθέτεις κι άλλες αν θες
];

const DEFAULT_LANG = "en";

// Language Context Wrapper
const LanguageWrapper = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  React.useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  return children;
};

// Το main layout (header, footer, chat) γύρω από routes
const Layout = ({ languages }) => (
  <>
    <Header languages={languages} />
    <Routes>
      <Route index element={<Home />} />
      <Route path="services" element={<Services />} />
      <Route path="portfolio" element={<Portfolio />} />
      <Route path="about" element={<About />} />
      <Route path="appointment" element={<AppointmentPage />} />
      <Route path="blog" element={<Blog />} />
      <Route path="contact" element={<Contact />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="terms" element={<TermsOfService />} />
      {/* Μπορείς να προσθέσεις κι άλλα routes εδώ */}
    </Routes>
    <Footer />
  </>
);

const App = () => {
  if (MAINTENANCE_MODE) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenancePage />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Redirect root στο default lang */}
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />

          {/* Multilingual routes */}
          <Route
            path=":lang/*"
            element={
              <LanguageWrapper>
                <Layout languages={LANGUAGES} />
              </LanguageWrapper>
            }
          />

          {/* Catch-all fallback */}
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
        <ChatWidget />
      </Router>
    </ThemeProvider>
  );
};

export default App;
